import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {
    Aangifte, AangifteBerekening,
    AangifteRapport, BokkzAlgDataService, Box3Berekening, ClientEntity, IncomeTaxEntity,
    OpbouwBox3, OpbouwInkomenBox3, OpbouwOwr, SpecificatieBox3, SpecificatieOWR
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiAlertModule } from '@snelstart/ui-alert';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-box3-inkomen',
    templateUrl: './box3-inkomen.component.html',
    styleUrls: ['./box3-inkomen.component.scss'],
    imports: [
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        CommonModule,
        SharedUiButtonModule,
        SharedUiDialogModule,
        SharedUiAlertModule
    ]
})
export class Box3InkomenComponent implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public client = {} as ClientEntity;
    public clientId: any;

    @Input() partner = new BehaviorSubject<boolean>(false);

    specBox3FormGroup = this.fb.group<AangifteRapport>({});
    specBox3 = {} as AangifteRapport;
    specOWRFormGroup = this.fb.group<AangifteRapport>({});
    specOWR = {} as AangifteRapport;

    berekeningFormGroup = this.fb.group<AangifteBerekening>({});
    berekening = {} as AangifteBerekening;
    berekeningPartnerFormGroup = this.fb.group<AangifteBerekening>({});
    partnerBerekening = {} as AangifteBerekening;
    verdelingFormGroup = {} as FormGroup;
    box3BerekeningenFormGroup = {} as FormGroup;
    public dialogVisible = false;
    public dialogOWRVisible = false;
    public laagsteRendement = 0;

    showDialog() {
        this.dialogVisible = true;
    }

    showDialogOWR() {
        this.dialogOWRVisible = true;
    }

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder,
                private cdr: ChangeDetectorRef, private router: Router) {
        this.specBox3FormGroup = this.fb.group<AangifteRapport>(({
            specificatieBox3: this.fb.group<SpecificatieBox3>(({
                opbouw: this.fb.group<OpbouwBox3>({
                    verminderingVoordeelSparenEnBeleggen: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVermindering: null as unknown as number,
                    tijdsEvenredigeVermindering: null as unknown as number,
                    grondslagSparenEnBeleggen: null as unknown as number,
                    heffingsvrijVermogenAangever: null as unknown as number,
                    heffingsvrijVermogenPartner: null as unknown as number,
                    rendementsGrondslag: null as unknown as number,
                    voordeelUitSparenEnBeleggen: null as unknown as number,
                    grondslagNaVerdeling: null as unknown as number,
                    inkomenBox3: null as unknown as number,
                    rendementBanktegoedenNederland: null as unknown as number,
                    rendementBanktegoedenBuitenland: null as unknown as number,
                    rendementBeleggingen: null as unknown as number,
                    rendementOnroerendeZakenNederland: null as unknown as number,
                    rendementOnroerendeZakenBuitenland: null as unknown as number,
                    rendementVorderingen: null as unknown as number,
                    rendementContantGeld: null as unknown as number,
                    rendementCrypto: null as unknown as number,
                    rendementBouwdepot: null as unknown as number,
                    rendementPremiedepot: null as unknown as number,
                    rendementKapitaalverzekeringen: null as unknown as number,
                    rendementPeriodiekeUitkeringen: null as unknown as number,
                    rendementOverigeBezittingen: null as unknown as number,
                    rendementNettoPensioen: null as unknown as number,
                    rendementAftrekbareSchulden: null as unknown as number,
                    totaalRendement: null as unknown as number,
                    waardeBezittingenBinnenlandsePeriode: null as unknown as number,
                    waardeSchuldenBinnenlandsePeriode: null as unknown as number,
                    waardeBezittingenBuitenlandsePeriode: null as unknown as number,
                    waardeSchuldenBuitenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBinnenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBuitenlandsePeriode: null as unknown as number,
                    drempelSchuldenBinnenlandsePeriode: null as unknown as number,
                    drempelSchuldenBuitenlandsePeriode: null as unknown as number,
                    grondslagBinnenlandsePeriode: null as unknown as number,
                    grondslagBuitenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBinnenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBuitenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBinnenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBuitenlandsePeriode: null as unknown as number,
                    eldersBelasteRechtenOnroerendeZakenBuitenland: null as unknown as number,
                    verminderingVanwegeEldersBelasteRechtenBuitenland: null as unknown as number,
                    bezittingenDieMeetellenVoorTijdsevenredigeHerleidingBinnenlandsePeriode: null as unknown as number,
                    verminderingVoordeelTijdevenredigeHerleiding: null as unknown as number,
                    voordeelUitSparenEnBelegenBinnenlandsePeriode: null as unknown as number,
                    voordeelUitSparenEnBelegenBuitenlandsePeriode: null as unknown as number,
                    banktegoedenNederland: null as unknown as number,
                    banktegoedenBuitenland: null as unknown as number,
                    beleggingen: null as unknown as number,
                    groeneBeleggingen: null as unknown as number,
                    groeneBeleggingenBanktegoeden: null as unknown as number,
                    groeneBeleggingenEffecten: null as unknown as number,
                    vrijstellingGroeneBeleggingen: null as unknown as number,
                    vrijstellingGroeneBeleggingenBanktegoeden: null as unknown as number,
                    vrijstellingGroeneBeleggingenEffecten: null as unknown as number,
                    onroerendeZaken: null as unknown as number,
                    vorderingen: null as unknown as number,
                    periodiekeUitkeringen: null as unknown as number,
                    kapitaalverzekeringen: null as unknown as number,
                    premieDepots: null as unknown as number,
                    bouwDepots: null as unknown as number,
                    contantGeld: null as unknown as number,
                    nettoPensioen: null as unknown as number,
                    overigeBezittingen: null as unknown as number,
                    schuldenNederlandsOG: null as unknown as number,
                    schuldenBuitenlandsOG: null as unknown as number,
                    overigeSchulden: null as unknown as number,
                    totaleSchulden: null as unknown as number,
                    schuldenDrempel: null as unknown as number,
                    schuldenNaDrempel: null as unknown as number
                })
            } as SpecificatieBox3))
        } as AangifteRapport));
        this.specOWRFormGroup = this.fb.group<AangifteRapport>(({
            specificatieOwr: this.fb.group<SpecificatieOWR>(({
                opbouw: this.fb.group<OpbouwOwr>({
                    werkelijkRendement: null as unknown as number,
                    negatiefRendement: null as unknown as number,
                    rendementBankrekeningenNederland: null as unknown as number,
                    rendementBankrekeningenBuitenland: null as unknown as number,
                    rendementBankrekeningenGroen: null as unknown as number,
                    rendementEffecten: null as unknown as number,
                    rendementEffectenGroen: null as unknown as number,
                    rendementOnroerendeZakenNl: null as unknown as number,
                    rendementOnroerendeZakenBtl: null as unknown as number,
                    rendementContantGeld: null as unknown as number,
                    rendementCrypto: null as unknown as number,
                    rendementBouwdepot: null as unknown as number,
                    rendementPremieDepot: null as unknown as number,
                    rendementVorderingen: null as unknown as number,
                    rendementKapitaalverzekeringen: null as unknown as number,
                    rendementPeriodiekeUitkeringen: null as unknown as number,
                    rendementOverigeBezittingen: null as unknown as number,
                    rendementSchuldenOgNederland: null as unknown as number,
                    rendementSchuldenOgBuitenland: null as unknown as number,
                    rendementSchuldenOgOverig: null as unknown as number
                })
            } as SpecificatieOWR))
        } as AangifteRapport));
        this.berekeningFormGroup = this.fb.group<AangifteBerekening>(({
            box3: this.fb.group<Box3Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwInkomenBox3>(({
                    voordeelUitSparenEnBeleggen: 0,
                    forfaitairVoordeelUitSparenEnBeleggen: null as unknown as number,
                    werkelijkVoordeelUitSparenEnBeleggen: null as unknown as number,
                    grondslagNaVerdeling: null as unknown as number,
                    grondslagSparenEnBeleggen: null as unknown as number,
                    rendementsGrondslagNaVerdeling: null as unknown as number,
                    rendementsGrondslag: null as unknown as number
                } as OpbouwInkomenBox3))
            } as Box3Berekening))
        } as AangifteBerekening));
        this.berekeningPartnerFormGroup = this.fb.group<AangifteBerekening>(({
            partnerBerekening: this.fb.group<AangifteBerekening>(({
                box3: this.fb.group<Box3Berekening>(({
                    inkomen: null as unknown as number,
                    persoonsgebondenAftrek: null as unknown as number,
                    belastbaarInkomen: null as unknown as number,
                    opbouwInkomen: this.fb.group<OpbouwBox3>(({
                        forfaitairVoordeelUitSparenEnBeleggen: null as unknown as number,
                        werkelijkVoordeelUitSparenEnBeleggen: null as unknown as number,
                        voordeelUitSparenEnBeleggen: null as unknown as number,
                        grondslagNaVerdeling: null as unknown as number,
                        grondslagSparenEnBeleggen: null as unknown as number,
                        rendementsGrondslagNaVerdeling: null as unknown as number,
                        rendementsGrondslag: null as unknown as number
                    } as OpbouwBox3))
                } as Box3Berekening))
            } as AangifteBerekening))
        } as AangifteBerekening));
        this.verdelingFormGroup = this.fb.group({
            aandeelAangeverGrondslagSparenEnBeleggen: null as unknown as number,
            aandeelPartnerGrondslagSparenEnBeleggen: null as unknown as number,
            berekeningAandeelAangever: null as unknown as string,
            berekeningAandeelPartner: null as unknown as string,
            gecombineerdeWaardeAangever: null as unknown as string,
            gecombineerdeWaardePartner: null as unknown as string
        });
        this.box3BerekeningenFormGroup = this.fb.group({
            percentageAangeverRendementsgrondslag: null as unknown as number,
            percentagePartnerRendementsgrondslag: null as unknown as number,
            gecombineerdeWaardeZonderPartner: null as unknown as string,
            percentageAangeverRendementsgrondslagZonderPartner: null as unknown as number,
            percentageAangeverRendementsgrondslagMetPartner: null as unknown as number
        });
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specBox3FormGroup.reset();
                    this.specBox3 = value;
                    this.specBox3FormGroup.patchValue(this.specBox3);
                });
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specOWRFormGroup.reset();
                    this.specOWR = value;
                    this.specOWRFormGroup.patchValue(this.specOWR);
                    this.specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'negatiefRendement'])?.setValue(0);
                    this.berekenLaagsteRendement();
                });
                this.dataService.aangifteBerekening.subscribe((value) => {
                    this.berekeningFormGroup.reset();
                    this.berekening = value;
                    const voordeel = this.berekeningFormGroup.get('box3.opbouwInkomen.voordeelUitSparenEnBeleggen');
                    if (voordeel && voordeel.value == null) {
                        voordeel.setValue(0);
                    }
                    this.berekeningFormGroup.patchValue(this.berekening);
                    const aandeelPartnerRendementsGrondslag = this.incomeTaxEntity.aangifte?.partnerAangifte?.verdeling?.aandeelBox3;
                    if (aandeelPartnerRendementsGrondslag !== undefined) {
                        this.berekeningPartnerFormGroup.reset();
                        this.partnerBerekening = value;
                        const voordeel = this.berekeningPartnerFormGroup.get('box3.opbouwInkomen.voordeelUitSparenEnBeleggen');
                        if (voordeel && voordeel.value == null) {
                            voordeel.setValue(0);
                        }
                        this.berekeningPartnerFormGroup.patchValue(this.partnerBerekening);
                    }
                });
                const aandeelRendementsGrondslag = this.incomeTaxEntity.aangifte?.verdeling?.aandeelBox3;
                this.verdelingFormGroup.reset();
                if (aandeelRendementsGrondslag !== undefined) {
                    this.verdelingFormGroup.reset();
                    this.verdelingFormGroup.patchValue({
                        aandeelAangeverGrondslagSparenEnBeleggen: aandeelRendementsGrondslag
                    });
                } else if (this.berekening.box3?.opbouwInkomen?.rendementsGrondslag !== null) {
                    this.verdelingFormGroup.patchValue({
                        aandeelAangeverGrondslagSparenEnBeleggen: this.berekening.box3?.opbouwInkomen?.rendementsGrondslag
                    });
                }
                const aandeelPartnerRendementsGrondslag = this.incomeTaxEntity.aangifte?.partnerAangifte?.verdeling?.aandeelBox3;
                if (aandeelPartnerRendementsGrondslag !== undefined) {
                    this.verdelingFormGroup.patchValue({
                        aandeelPartnerGrondslagSparenEnBeleggen: aandeelPartnerRendementsGrondslag
                    });
                }
                this.box3Berekeningen();
                this.disableFormGroup(this.specBox3FormGroup);
                this.disableFormGroup(this.specOWRFormGroup);
                this.disableFormGroup(this.verdelingFormGroup);
                this.disableFormGroup(this.box3BerekeningenFormGroup);
                this.disableFormGroup(this.berekeningFormGroup);
                this.disableFormGroup(this.berekeningPartnerFormGroup);
            }
        });

    }

    box3Berekeningen() {
        const rendementsGrondslag = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value;
        const aandeelAangeverInRendementsGrondslag = this.verdelingFormGroup.get(['aandeelAangeverGrondslagSparenEnBeleggen'])?.value;
        const aandeelPartnerInRendementsGrondslag = this.verdelingFormGroup.get(['aandeelPartnerGrondslagSparenEnBeleggen'])?.value;
        const grondslagSparenEnBeleggen = this.berekeningFormGroup.get(['box3', 'opbouwInkomen', 'grondslagSparenEnBeleggen'])?.value;

        // const formatter = new Intl.NumberFormat('nl-NL');
        // const formattedAandeelAangever = formatter.format(aandeelAangeverInRendementsGrondslag);
        // const formattedAandeelPartner = formatter.format(aandeelAangeverInRendementsGrondslag);
        // const formattedRendementsGrondslag = formatter.format(rendementsGrondslag);
        // this.verdelingFormGroup.patchValue({
        //     gecombineerdeWaardeAangever: `${formattedAandeelAangever} / ${formattedRendementsGrondslag}`,
        //     gecombineerdeWaardePartner: `${formattedAandeelPartner} / ${formattedRendementsGrondslag}`,
        // });

        if (rendementsGrondslag && rendementsGrondslag > 0) {
            const percentageAangeverRendementsgrondslag = Math.floor((aandeelAangeverInRendementsGrondslag / rendementsGrondslag) * 10000) / 100;
            const percentagePartnerRendementsgrondslag = Math.floor((aandeelPartnerInRendementsGrondslag / rendementsGrondslag) * 10000) / 100;
            const percentageAangeverRendementsgrondslagZonderPartner = Math.floor((grondslagSparenEnBeleggen / rendementsGrondslag) * 10000) / 100;
            this.box3BerekeningenFormGroup.patchValue({
                percentageAangeverRendementsgrondslag: percentageAangeverRendementsgrondslag,
                percentagePartnerRendementsgrondslag: percentagePartnerRendementsgrondslag,
                percentageAangeverRendementsgrondslagZonderPartner: percentageAangeverRendementsgrondslagZonderPartner
            });
        }

        this.cdr.detectChanges();
    }

    get gecombineerdeWaardeAangever(): string {
        const rendementsGrondslag = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value;
        const aandeelAangeverInRendementsGrondslag = this.verdelingFormGroup.get(['aandeelAangeverGrondslagSparenEnBeleggen'])?.value;
        const formatter = new Intl.NumberFormat('nl-NL');
        const formattedAandeel = formatter.format(aandeelAangeverInRendementsGrondslag);
        const formattedRendementsGrondslag = formatter.format(rendementsGrondslag);

        return `${formattedAandeel} / ${formattedRendementsGrondslag}`;
    }

    get gecombineerdeWaardePartner(): string {
        const rendementsGrondslag = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value;
        const aandeelPartnerInRendementsGrondslag = this.verdelingFormGroup.get(['aandeelPartnerGrondslagSparenEnBeleggen'])?.value;
        const formatter = new Intl.NumberFormat('nl-NL');
        const formattedAandeel = formatter.format(aandeelPartnerInRendementsGrondslag);
        const formattedRendementsGrondslag = formatter.format(rendementsGrondslag);

        return `${formattedAandeel} / ${formattedRendementsGrondslag}`;
    }

    get gecombineerdeWaardeZonderPartner(): string {
        const rendementsGrondslag = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value;
        const grondslagSparenEnBeleggen = this.berekeningFormGroup.get(['box3', 'opbouwInkomen', 'grondslagSparenEnBeleggen'])?.value;
        const formatter = new Intl.NumberFormat('nl-NL');
        const formattedGrondslag = formatter.format(grondslagSparenEnBeleggen);
        const formattedRendementsGrondslag = formatter.format(rendementsGrondslag);

        return `${formattedGrondslag} / ${formattedRendementsGrondslag}`;
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    berekenLaagsteRendement(): void {
        const fictief = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'inkomenBox3'])?.value;
        const werkelijk = this.specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'werkelijkRendement'])?.value;

        if (fictief <= werkelijk) {
            this.laagsteRendement = fictief;
        } else {
            if (werkelijk <= 0) {
                this.laagsteRendement = 0;
            } else this.laagsteRendement = werkelijk;
        }
    }

}


